/** @format */

/**
 * 给uniapp发送消息
 * 调用示例：
 * postMessageUni({ data: { type: 'h5', action: '222', payload: {} } });
 * @param {*} message
 */
export function postMessageUni(message) {
	//('message', JSON.stringify(message));
	window.top.uni?.postMessage(message);
	// if (window.uniDataEnv.h5) {
	// 	// h5平台
	// 	// window.top.postMessage(message);
	// 	// window.uni.postMessage(message);
	// } else {
	// 	// 其他平台
	// 	window.top.uni.postMessage(message);
	// }
}

/**
 *
 *  调用示例：
 * 		postMessageWindow({ data: { type: 'h5', action: '222', payload: {} } });
 * @param {*} message
 */
export function postMessageWindow(message) {
	//console.log('message', JSON.stringify(message));
	top.postMessage(message);
}

export function addEventListenerWindow(callback) {
	top.addEventListener('message', callback);
}
export function removeEventListenerWindow(callback) {
	top.removeEventListener('message', callback);
}
